export const MANDATORY_FIELD = "Este campo é obrigatório";
